import { render, staticRenderFns } from "./LatestSchedules.vue?vue&type=template&id=71901035&scoped=true&"
import script from "./LatestSchedules.vue?vue&type=script&lang=js&"
export * from "./LatestSchedules.vue?vue&type=script&lang=js&"
import style0 from "./LatestSchedules.vue?vue&type=style&index=0&id=71901035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71901035",
  null
  
)

export default component.exports